import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Define styled components outside of the React component
const PageContainer = styled.div`
  padding: 20px;
  max-width: 100%;
  height: 100vh;
  margin-top: 5%;
`;

const Header = styled.h1`
  font-size: 2em;
  text-align: center;
  margin-bottom: 50px;
`;

const JobsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const JobCardLink = styled(Link)`
  width: 300px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  background: white;
  color: inherit; /* Ensures text inherits current color */
  text-decoration: none; /* Removes underline from links */
`;

const JobTitle = styled.h2`
  font-size: 1.2em;
  color: #333;
`;

const JobGroup = styled.div`
  font-size: 0.9em;
  color: #666;
  margin: 10px 0;
`;

const LocationTag = styled.span`
  display: inline-block;
  background: #e0e0e0;
  border-radius: 15px;
  padding: 5px 15px;
  font-size: 0.8em;
  margin-top: 15px;
`;

// Dummy data for job positions
const jobPositions = [
  { title: 'Electrician', group: 'Full-time', location: 'Richmond, Va' },
];

const Careers = () => {
  return (
    <div className='Careers'>
        <PageContainer>
            <div className='c-contain'>
              <p>
                We are always looking for hardworking team members to join our family. 
                View our current job opening below for electricians. 
                Have a rewarding career by taking part in an up and rising company who takes pride in the quality of work they deliver.
              </p>
            </div>
            <Header>Open Positions</Header>
            <JobsContainer>
                {jobPositions.map((job, index) => (
                    <JobCardLink to={`/careers/job/${index}`} key={index}>
                        <JobTitle>{job.title}</JobTitle>
                        <JobGroup>{job.group}</JobGroup>
                        <LocationTag>{job.location}</LocationTag>
                    </JobCardLink>
                ))}
            </JobsContainer>
        </PageContainer>
    </div>
  );
};

export default Careers;
